import * as Sentry from '@sentry/react';
import { APP_ENV, SENTRY_DSN } from 'env';

/* eslint-disable */
const sentrySetup = async () => {
    const shouldDeployed = ['develop', 'staging', 'production'].includes(APP_ENV);
    if (shouldDeployed) {
        Sentry.init({
            dsn: SENTRY_DSN,
            environment: APP_ENV,
            sendDefaultPii: true,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.captureConsoleIntegration({
                    levels: ['error'],
                }),
                Sentry.replayIntegration(),
            ],
            // Set tracesSampleRate to 1.0 to capture 100%
            tracesSampleRate: 1.0,
            // Capture Replay only for error sessions
            replaysSessionSampleRate: 0.0,
            replaysOnErrorSampleRate: 1.0,
        });
    }
};
/* eslint-enable */
export default sentrySetup;
